<template>
  <div class="etermin-step contact pb-5">
    <div class="form-wrapper row rows row-s">
      <div class="col-12 col-lg">
        <form class="v-form w-100 seconda bg-secondary-l border-radius-main h-100 p-lg-8 p-4 mb-lg-0 mb-4">
          <div class="v-form-title-container border-l-bottom-white mb-5">
            <h3 class="v-form-title mb-5 mt-0 text-left">
              {{ text.your_data }}
            </h3>
          </div>

          <div class="form-container">
            <div :class="`a-dropdown-abs position-relative type-vue ${genderDropdownOpened ? 'active': ''} ${selectedItem === null ? 'error' : ''}`">
              <div v-on:click.self="openGenderDropdown()" class="dropdown-label pointer d-flex justify-content-between align-items-center ">
                  <div class="d-flex flex-column justify-content-center">
                      <div class="text-gray-d">
                        {{ text.salutation }}
                      </div>
                      <p class="no-events text-gray-d"> {{ selectedItem }}</p>
                  </div>

                  <div v-on:click.self="openGenderDropdown()" class="dropdown-icon p-2 border-radius-main">
                      <div class="icon-wrapper border-radius-main no-overflow icon-sicon-square no-events">
                          <svg class="icon-base">
                              <use xlink:href="/dist/icons/solid.svg#chevron-down"></use>
                          </svg>
                      </div>
                  </div>
              </div>

              <div class="dropdown-items w-100 shadow-b-2">
                  <p v-on:click="updateSelectedGender('Herr')" class="mb-0 dropdown-part pointer text-gray-d">{{ text.mr }}</p>
                  <p v-on:click="updateSelectedGender('Frau')" class="mb-0 dropdown-part pointer text-gray-d">{{ text.mrs }}</p>
              </div>
            </div>

            <!-- need to fix this -->
            <span v-if="selectedItem === null || fields.salutation.validation === false" class="text-danger text-ss mb-3 d-block">
              {{ text.input_required }}
            </span>

            <div class="vornach d-flex flex-row mt-3">
              <div class="a-input-form-wrapper flex-1 vor w-100 me-1">
                <div class="v-input-wrapper position-relative wrapper w-100 mb-3" :class="{ 'errorForm': fields.firstname.validation===false }">
                  <label class="w-100 position-relative">
                    <input class="v-input border-radius-main bg-white border-0 p text-left w-100" placeholder=" " v-model="appointement.contact.firstname" @blur="validateRequired('firstname')"/>
                    <span class="input-placeholder position-absolute text-gray-d">
                      {{ text.first_name }}
                    </span>
                  </label>
                  <div class="input-error-message text-danger text-align-left text-err" v-if="fields.firstname.validation===false" >{{ fields.firstname.errmessage}}</div>
                </div>
              </div>
              <div class="a-input-form-wrapper flex-1 nach w-100 ms-1">
                <div class="v-input-wrapper position-relative wrapper w-100 mb-3" :class="{ 'errorForm': fields.lastname.validation===false }">
                  <label class="w-100 position-relative">
                    <input class="v-input border-radius-main bg-white border-0 p text-left w-100" placeholder=" " v-model="appointement.contact.lastname" @blur="validateRequired('lastname')" />
                    <span class="input-placeholder position-absolute text-gray-d">
                      {{ text.last_name }}
                    </span>
                  </label>
                  <div class="input-error-message text-danger text-align-left text-err" v-if="fields.lastname.validation===false" >{{ fields.lastname.errmessage}}</div>
                </div>
              </div>
            </div>
            <div class="a-input-form-wrapper">
              <div class="v-input-wrapper position-relative wrapper w-100 mb-3" :class="{ 'errorForm': fields.telephone.validation===false }">
                <label class="w-100 position-relative">
                  <input class="v-input border-radius-main bg-white border-0 p text-left w-100" type="tel" placeholder=" " v-model="appointement.contact.telephone" @blur="validateTelephon('telephone')"/>
                  <span class="input-placeholder position-absolute text-gray-d">
                    {{ text.phone }}
                  </span>
                </label>
                <div class="input-error-message text-danger text-align-left text-err" v-if="fields.telephone.validation===false" >{{ fields.telephone.errmessage}}</div>
              </div>
            </div>
            <div class="a-input-form-wrapper">
              <div class="v-input-wrapper position-relative wrapper w-100 mb-3" :class="{ 'errorForm': fields.email.validation===false }">
                <label class="w-100 position-relative">
                  <input class="v-input border-radius-main bg-white border-0 p text-left w-100" placeholder=" " v-model="appointement.contact.email" @blur="validateMail('email')"/>
                  <span class="input-placeholder position-absolute text-gray-d">
                    {{ text.email }}
                  </span>
                </label>
                <div class="input-error-message text-danger text-align-left text-err" v-if="fields.email.validation===false" >{{ fields.email.errmessage}}</div>
              </div>
            </div>
            <div class="a-input-form-wrapper">
              <div class="a-input-form-wrapper v-input-wrapper position-relative wrapper w-100 position-relative input-textarea">
                <textarea class="v-input border-radius-main bg-white text-left w-100 v-textarea" placeholder=" " v-model="appointement.contact.description"></textarea>
                <span class="input-placeholder position-absolute text-gray-d">
                  {{ text.remarks }}
                </span>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="col-12 col-lg">
        <div class="v-side text-left bg-secondary-l h-100 border-radius-main p-lg-8 p-4">
          <div class="v-side-title-container">
            <h3 class="v-side-title pb-5 mt-0 text-left border-l-bottom-white mb-5">
              {{ text.summary }}
            </h3>
          </div>
          <div class="v-side-container">
            <div class="d-flex flex-row justify-content-between">
              <h4 class="mb-2 bordered v-sub-title">
                {{ text.store }}
              </h4>
              <div class="andern">
                <p class="m-0 back pointer text-s" @click="MoveToSearch"> <font-awesome-icon class="me-2" icon="pen"/>
                  {{ text.change }}
                </p>
              </div>
            </div>
            <div class="result mb-5 v-flex justify-content-between v-side-result border-radius-main line-1 bg-white p-4">
              <div class="result-left">
                <h4 class="font-weight-bold mb-1 line-1 p">{{ selectedStore.title }}</h4>
                <p class="m-0 font-regular text-s">{{ selectedStore.address }}</p>
                <p class="m-0 font-regular text-s">{{ selectedStore.zip }} {{ selectedStore.city }}</p>
                <p class="m-0 font-regular text-s">{{ selectedStore.phone }}</p>
              </div>
            </div>
            <div class="d-flex flex-row justify-content-between">
              <h4 class="mb-2 v-sub-title">
                {{ text.date_time }}
              </h4>
              <div class="andern">
                <p class="m-0 back pointer font-weight-600 text-s" @click="MoveToStep(1)"> <font-awesome-icon class="me-2" icon="pen"/>
                  {{ text.change }}
                </p>
              </div>
            </div>
            <div class="result mb-5 v-flex justify-content-between v-side-result border-radius-main line-1 bg-white p-4">
              <div class="result-left">
                <p class="m-0 font-weight-bold text-s">{{ getDate(appointement.date) }}</p>
                <p class="m-0 font-weight-bold text-s">{{ appointement.time }} - {{ getAppointementEnd(appointement.services[0],appointement.date, appointement.time) }} Uhr</p>
              </div>

            </div>
            <div class="d-flex flex-row justify-content-between">
              <h4 class="mb-2 v-sub-title">
                {{ text.services }}
              </h4>
              <div class="andern">
                <p class="m-0 back pointer font-weight-600 text-s" @click="MoveToStep(0)"><font-awesome-icon class="me-2" icon="pen"/>
                  {{ text.change }}
                </p>
              </div>
            </div>
            <div class="result mb-5 v-flex justify-content-between v-side-result border-radius-main line-1 bg-white p-4">
              <div class="result-left">
                <div v-for="(item, index) in appointement.services" :key="item.id" v-bind:class="{ 'mb-2': index <= appointement.services.length - 2 }" class="service-item d-flex align-items-center">
                  <img class="me-2" :src="getServiceImage(item)" width="25"/>
                  <p class="font-weight-bold text-s" v-html="getServiceName(item)"></p>
                </div>
              </div>
            </div>
          </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import ServiceDrupal from '@/services/ServiceDrupal.js'
import moment from "moment";

export default {
    name: 'daten-step',
    props: {
        appointement: {
            type: Object,
            required: true
        },
        fields: {
            type: Object,
            required: true
        },
        format: {
            type: String,
            required: true
        }
    },
    data () {
        return {
            id: 2,
            isActive: false,
            selectedItem: (this.appointement.contact.salutation) ?  (Drupal.t(this.appointement.contact.salutation) === 'mr' ? 'Herr' : 'Frau'): '',
            genderDropdownOpened: false,
            text: {
                your_data: Drupal.t('Your data'),
                salutation: Drupal.t('Salutation*'),
                mr: Drupal.t('Mr'),
                mrs: Drupal.t('Mrs'),
                input_required: Drupal.t('Input required'),
                first_name: Drupal.t('First name*'),
                last_name: Drupal.t('Last name*'),
                phone: Drupal.t('Phone*'),
                email: Drupal.t('E-Mail*'),
                remarks: Drupal.t('Remarks'),
                summary: Drupal.t('Summary'),
                store: Drupal.t('Store'),
                change: Drupal.t('Change'),
                date_time: Drupal.t('Date & Time'),
                services: 'Services' // no translation needed
            }
        }
    },
    computed: {
        ...mapState({
            steps: state => state.etermin.steps
        }),
        ...mapGetters('etermin', ['getActiveStep']),
        ...mapGetters('etermin', ['getTime']),
        ...mapGetters('etermin', ['getDate']),
        ...mapGetters('etermin', ['getServiceName']),
        ...mapGetters('etermin', ['getServiceImage']),
        ...mapGetters('etermin', ['getAppointementEnd']),
        ...mapState([
            'selectedStore'
        ]),
    },
    methods: {
        MoveToStep: function (index) {
            this.$store.dispatch('etermin/updateSteps', index)
        },
        MoveToSearch: function () {
            if (this.format === 'normal') {
                location.href = '/filial-suche'
            } else {
                this.$emit('closeApp')
            }
        },
        validateRequired (field) {
            this.$emit('validateRequired', field)
        },
        validateMail (field) {
            this.$emit('validateMail', field)
        },
        validateTelephon (field) {
            this.$emit('validateTelephon', field)
        },
        validateSalutation (field) {
            this.$emit('validateSalutation', field)
        },
        updateSelectedGender (gender) {
            this.genderDropdownOpened = false
            this.selectedItem = gender
            this.appointement.contact.salutation = (gender === 'Herr') ? 'mr' : 'mrs'
        },
        openGenderDropdown () {
            this.genderDropdownOpened = !this.genderDropdownOpened

            if (!this.genderDropdownOpened && this.selectedItem === '') {
                this.selectedItem = null
            }
        }
    },
    async mounted () {
         this.$emit(`mounted`)
         /*await this.$store.dispatch('etermin/getCustomersCustomFields', {
            calenderid : this.selectedStore.calenderid
         })*/
    }
}
</script>

<style lang="css">

</style>
